<div class="form-title">
  <label><ng-content></ng-content></label>
</div>
